import { Link } from "react-router-dom";
import { SiteFooter, SiteHeader } from "./BrandLogo";

export const AuthCard = ({ eyebrow, title, children, testid }) => (
  <div className="confetti-bg-white font-manrope flex min-h-screen flex-col text-slate-900">
    <SiteHeader>
      <Link to="/login" data-testid="auth-login-link" className="text-sm font-medium text-slate-600 transition-colors hover:text-blue-700">Log in</Link>
    </SiteHeader>
    <div className="flex flex-1 items-start justify-center px-4 pb-16 pt-10 sm:items-center">
      <div data-testid={testid} className="rise w-full max-w-md rounded-2xl border border-slate-200 bg-white/90 p-8 shadow-sm backdrop-blur-xl sm:p-10">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-blue-700">{eyebrow}</p>
        <h1 className="font-display mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
        {children}
      </div>
    </div>
    <SiteFooter />
  </div>
);
